export default __webpack_public_path__ + "./image/e3ed853ab36721c293cb7e52e4611a9b.png";